module.exports = __webpack_public_path__ + "static/historical2-8d5f946092cb43ccd5cf31eb5fd7775d.jpg";